export default __webpack_public_path__ + "static/media/hero-section.8187de50.png";